import { createContext, useContext, useState, useCallback } from 'react';

const LanguageContext = createContext();

const translations = {
  en: {
    nav: {
      home: 'Home',
      events: 'Events',
      studio: 'The Studio',
      inquiry: 'Boutique Inquiry',
      admin: 'Admin',
    },
    hero: {
      badge: 'Luxury Laser Branding',
      title: 'Art. Events. Studio.',
      subtitle: 'Precision laser engraving meets digital innovation. Create personalized masterpieces and smart NFC experiences.',
      cta1: 'Book an Event',
      cta2: 'Explore the Studio',
      cta3: 'Personalized Masterpiece',
    },
    nfcDemo: {
      title: 'Smart NFC Technology',
      subtitle: 'One tap. Infinite connections.',
      description: 'Our laser-engraved NFC cards create instant digital bridges between the physical and virtual worlds.',
    },
    services: {
      title: 'Our Services',
      subtitle: 'Three pillars of luxury laser craftsmanship',
      events: 'Live Events',
      eventsDesc: 'On-site laser personalization for corporate events, product launches, and luxury experiences.',
      studio: 'The Studio',
      studioDesc: 'Bespoke laser engravings on premium materials — slate, wood, metal, and leather.',
      nfc: 'Digital NFC Cards',
      nfcDesc: 'Smart business cards with laser-engraved designs and dynamic digital profiles.',
    },
    events: {
      title: 'Events',
      subtitle: 'Luxury experiences, unforgettable moments',
      corporate: 'Corporate',
      private: 'Private',
      corporateTitle: 'Corporate Events',
      corporateDesc: 'Drive ROI with on-site laser branding. Engage attendees, create lasting impressions, and deliver measurable results.',
      privateTitle: 'Private Events',
      privateDesc: 'Transform special occasions into luxury memories. Weddings, anniversaries, and exclusive celebrations.',
      roiTitle: 'ROI Calculator',
      roiSubtitle: 'See the impact of live laser branding at your next event',
      attendees: 'Expected Attendees',
      avgDeal: 'Average Deal Value ($)',
      conversionRate: 'Conversion Rate (%)',
      calculate: 'Calculate ROI',
      projectedLeads: 'Projected Leads',
      projectedRevenue: 'Projected Revenue',
      roiMultiplier: 'ROI Multiplier',
    },
    studio: {
      title: 'The Studio',
      subtitle: 'Micron-level precision on premium materials',
      all: 'All',
      slate: 'Slate',
      wood: 'Wood',
      metal: 'Metal',
      leather: 'Leather',
    },
    inquiry: {
      title: 'Boutique Inquiry',
      subtitle: 'Tell us about your vision',
      step1: 'Style',
      step2: 'Details',
      step3: 'Upload',
      step4: 'Review',
      selectStyle: 'Choose Your Style',
      classic: 'Classic',
      comic: 'Comic',
      portrait: 'Portrait',
      name: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      material: 'Preferred Material',
      description: 'Describe Your Vision',
      uploadFile: 'Upload Reference File',
      marketingOptIn: 'I agree to receive marketing communications (optional)',
      submit: 'Submit Inquiry',
      back: 'Back',
      next: 'Next',
    },
    footer: {
      tagline: 'Precision meets artistry.',
      rights: 'All rights reserved.',
    },
  },
  he: {
    nav: {
      home: '\u05D1\u05D9\u05EA',
      events: '\u05D0\u05D9\u05E8\u05D5\u05E2\u05D9\u05DD',
      studio: '\u05D4\u05E1\u05D8\u05D5\u05D3\u05D9\u05D5',
      inquiry: '\u05D1\u05D5\u05D8\u05D9\u05E7',
      admin: '\u05E0\u05D9\u05D4\u05D5\u05DC',
    },
    hero: {
      badge: '\u05DE\u05D9\u05EA\u05D5\u05D2 \u05DC\u05D9\u05D9\u05D6\u05E8 \u05D9\u05D5\u05E7\u05E8\u05EA\u05D9',
      title: '\u05D0\u05DE\u05E0\u05D5\u05EA. \u05D0\u05D9\u05E8\u05D5\u05E2\u05D9\u05DD. \u05E1\u05D8\u05D5\u05D3\u05D9\u05D5.',
      subtitle: '\u05D7\u05E8\u05D9\u05D8\u05EA \u05DC\u05D9\u05D9\u05D6\u05E8 \u05DE\u05D3\u05D5\u05D9\u05E7\u05EA \u05E4\u05D5\u05D2\u05E9\u05EA \u05D7\u05D3\u05E9\u05E0\u05D5\u05EA \u05D3\u05D9\u05D2\u05D9\u05D8\u05DC\u05D9\u05EA.',
      cta1: '\u05D4\u05D6\u05DE\u05E0\u05EA \u05D0\u05D9\u05E8\u05D5\u05E2',
      cta2: '\u05D2\u05DC\u05D4 \u05D0\u05EA \u05D4\u05E1\u05D8\u05D5\u05D3\u05D9\u05D5',
      cta3: '\u05D9\u05E6\u05D9\u05E8\u05D4 \u05D0\u05D9\u05E9\u05D9\u05EA',
    },
    nfcDemo: {
      title: '\u05D8\u05DB\u05E0\u05D5\u05DC\u05D5\u05D2\u05D9\u05D9\u05EA NFC \u05D7\u05DB\u05DE\u05D4',
      subtitle: '\u05E0\u05D2\u05D9\u05E2\u05D4 \u05D0\u05D7\u05EA. \u05D7\u05D9\u05D1\u05D5\u05E8\u05D9\u05DD \u05D0\u05D9\u05E0\u05E1\u05D5\u05E4\u05D9\u05D9\u05DD.',
      description: '\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9 NFC \u05D4\u05D7\u05E8\u05D5\u05D8\u05D9\u05DD \u05D1\u05DC\u05D9\u05D9\u05D6\u05E8 \u05D9\u05D5\u05E6\u05E8\u05D9\u05DD \u05D2\u05E9\u05E8\u05D9\u05DD \u05D3\u05D9\u05D2\u05D9\u05D8\u05DC\u05D9\u05D9\u05DD.',
    },
    services: {
      title: '\u05D4\u05E9\u05D9\u05E8\u05D5\u05EA\u05D9\u05DD \u05E9\u05DC\u05E0\u05D5',
      subtitle: '\u05E9\u05DC\u05D5\u05E9\u05D4 \u05E2\u05DE\u05D5\u05D3\u05D9\u05DD \u05E9\u05DC \u05D0\u05DE\u05E0\u05D5\u05EA \u05DC\u05D9\u05D9\u05D6\u05E8 \u05D9\u05D5\u05E7\u05E8\u05EA\u05D9\u05EA',
      events: '\u05D0\u05D9\u05E8\u05D5\u05E2\u05D9\u05DD \u05D7\u05D9\u05D9\u05DD',
      eventsDesc: '\u05D4\u05EA\u05D0\u05DE\u05D4 \u05D0\u05D9\u05E9\u05D9\u05EA \u05D1\u05DC\u05D9\u05D9\u05D6\u05E8 \u05D1\u05D0\u05D9\u05E8\u05D5\u05E2\u05D9\u05DD \u05EA\u05D0\u05D2\u05D9\u05D3\u05D9\u05D9\u05DD.',
      studio: '\u05D4\u05E1\u05D8\u05D5\u05D3\u05D9\u05D5',
      studioDesc: '\u05D7\u05E8\u05D9\u05D8\u05D5\u05EA \u05DC\u05D9\u05D9\u05D6\u05E8 \u05DE\u05D5\u05EA\u05D0\u05DE\u05D5\u05EA \u05D0\u05D9\u05E9\u05D9\u05EA \u05E2\u05DC \u05D7\u05D5\u05DE\u05E8\u05D9\u05DD \u05DE\u05E2\u05D5\u05DC\u05D9\u05DD.',
      nfc: '\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9 NFC \u05D3\u05D9\u05D2\u05D9\u05D8\u05DC\u05D9\u05D9\u05DD',
      nfcDesc: '\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9 \u05D1\u05D9\u05E7\u05D5\u05E8 \u05D7\u05DB\u05DE\u05D9\u05DD \u05E2\u05DD \u05E2\u05D9\u05E6\u05D5\u05D1\u05D9\u05DD \u05D7\u05E8\u05D5\u05D8\u05D9\u05DD \u05D1\u05DC\u05D9\u05D9\u05D6\u05E8.',
    },
    events: {
      title: '\u05D0\u05D9\u05E8\u05D5\u05E2\u05D9\u05DD',
      subtitle: '\u05D7\u05D5\u05D5\u05D9\u05D5\u05EA \u05D9\u05D5\u05E7\u05E8\u05EA\u05D9\u05D5\u05EA, \u05E8\u05D2\u05E2\u05D9\u05DD \u05D1\u05DC\u05EA\u05D9 \u05E0\u05E9\u05DB\u05D7\u05D9\u05DD',
      corporate: '\u05EA\u05D0\u05D2\u05D9\u05D3\u05D9',
      private: '\u05E4\u05E8\u05D8\u05D9',
      corporateTitle: '\u05D0\u05D9\u05E8\u05D5\u05E2\u05D9\u05DD \u05EA\u05D0\u05D2\u05D9\u05D3\u05D9\u05D9\u05DD',
      corporateDesc: '\u05D4\u05E0\u05D9\u05E2\u05D5 ROI \u05E2\u05DD \u05DE\u05D9\u05EA\u05D5\u05D2 \u05DC\u05D9\u05D9\u05D6\u05E8 \u05D1\u05D0\u05D9\u05E8\u05D5\u05E2\u05D9\u05DD.',
      privateTitle: '\u05D0\u05D9\u05E8\u05D5\u05E2\u05D9\u05DD \u05E4\u05E8\u05D8\u05D9\u05D9\u05DD',
      privateDesc: '\u05D4\u05E4\u05DB\u05D5 \u05D0\u05D9\u05E8\u05D5\u05E2\u05D9\u05DD \u05DE\u05D9\u05D5\u05D7\u05D3\u05D9\u05DD \u05DC\u05D6\u05D9\u05DB\u05E8\u05D5\u05E0\u05D5\u05EA \u05D9\u05D5\u05E7\u05E8\u05EA\u05D9\u05D9\u05DD.',
      roiTitle: '\u05DE\u05D7\u05E9\u05D1\u05D5\u05DF ROI',
      roiSubtitle: '\u05E8\u05D0\u05D5 \u05D0\u05EA \u05D4\u05D4\u05E9\u05E4\u05E2\u05D4 \u05E9\u05DC \u05DE\u05D9\u05EA\u05D5\u05D2 \u05DC\u05D9\u05D9\u05D6\u05E8',
      attendees: '\u05DE\u05E1\u05E4\u05E8 \u05DE\u05E9\u05EA\u05EA\u05E4\u05D9\u05DD \u05E6\u05E4\u05D5\u05D9',
      avgDeal: '\u05E2\u05E8\u05DA \u05E2\u05E1\u05E7\u05D4 \u05DE\u05DE\u05D5\u05E6\u05E2 ($)',
      conversionRate: '\u05E9\u05D9\u05E2\u05D5\u05E8 \u05D4\u05DE\u05E8\u05D4 (%)',
      calculate: '\u05D7\u05E9\u05D1 ROI',
      projectedLeads: '\u05DC\u05D9\u05D3\u05D9\u05DD \u05E6\u05E4\u05D5\u05D9\u05D9\u05DD',
      projectedRevenue: '\u05D4\u05DB\u05E0\u05E1\u05D4 \u05E6\u05E4\u05D5\u05D9\u05D4',
      roiMultiplier: '\u05DE\u05DB\u05E4\u05D9\u05DC ROI',
    },
    studio: {
      title: '\u05D4\u05E1\u05D8\u05D5\u05D3\u05D9\u05D5',
      subtitle: '\u05D3\u05D9\u05D5\u05E7 \u05D1\u05E8\u05DE\u05EA \u05DE\u05D9\u05E7\u05E8\u05D5\u05DF \u05E2\u05DC \u05D7\u05D5\u05DE\u05E8\u05D9\u05DD \u05DE\u05E2\u05D5\u05DC\u05D9\u05DD',
      all: '\u05D4\u05DB\u05DC',
      slate: '\u05E6\u05E4\u05D7\u05D4',
      wood: '\u05E2\u05E5',
      metal: '\u05DE\u05EA\u05DB\u05EA',
      leather: '\u05E2\u05D5\u05E8',
    },
    inquiry: {
      title: '\u05D1\u05D5\u05D8\u05D9\u05E7',
      subtitle: '\u05E1\u05E4\u05E8\u05D5 \u05DC\u05E0\u05D5 \u05E2\u05DC \u05D4\u05D7\u05D6\u05D5\u05DF \u05E9\u05DC\u05DB\u05DD',
      step1: '\u05E1\u05D2\u05E0\u05D5\u05DF',
      step2: '\u05E4\u05E8\u05D8\u05D9\u05DD',
      step3: '\u05D4\u05E2\u05DC\u05D0\u05D4',
      step4: '\u05E1\u05E7\u05D9\u05E8\u05D4',
      selectStyle: '\u05D1\u05D7\u05E8\u05D5 \u05E1\u05D2\u05E0\u05D5\u05DF',
      classic: '\u05E7\u05DC\u05D0\u05E1\u05D9',
      comic: '\u05E7\u05D5\u05DE\u05D9\u05E7\u05E1',
      portrait: '\u05E4\u05D5\u05E8\u05D8\u05E8\u05D8',
      name: '\u05E9\u05DD \u05DE\u05DC\u05D0',
      email: '\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC',
      phone: '\u05D8\u05DC\u05E4\u05D5\u05DF',
      material: '\u05D7\u05D5\u05DE\u05E8 \u05DE\u05D5\u05E2\u05D3\u05E3',
      description: '\u05EA\u05D0\u05E8\u05D5 \u05D0\u05EA \u05D4\u05D7\u05D6\u05D5\u05DF \u05E9\u05DC\u05DB\u05DD',
      uploadFile: '\u05D4\u05E2\u05DC\u05D0\u05EA \u05E7\u05D5\u05D1\u05E5 \u05D4\u05EA\u05D9\u05D9\u05D7\u05E1\u05D5\u05EA',
      marketingOptIn: '\u05D0\u05E0\u05D9 \u05DE\u05E1\u05DB\u05D9\u05DD/\u05D4 \u05DC\u05E7\u05D1\u05DC \u05EA\u05E7\u05E9\u05D5\u05E8\u05EA \u05E9\u05D9\u05D5\u05D5\u05E7\u05D9\u05EA (\u05D0\u05D5\u05E4\u05E6\u05D9\u05D5\u05E0\u05DC\u05D9)',
      submit: '\u05E9\u05DC\u05D7 \u05E4\u05E0\u05D9\u05D9\u05D4',
      back: '\u05D7\u05D6\u05E8\u05D4',
      next: '\u05D4\u05D1\u05D0',
    },
    footer: {
      tagline: '\u05D3\u05D9\u05D5\u05E7 \u05E4\u05D5\u05D2\u05E9 \u05D0\u05DE\u05E0\u05D5\u05EA.',
      rights: '\u05DB\u05DC \u05D4\u05D6\u05DB\u05D5\u05D9\u05D5\u05EA \u05E9\u05DE\u05D5\u05E8\u05D5\u05EA.',
    },
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('en');

  const t = useCallback(
    (path) => {
      const keys = path.split('.');
      let value = translations[lang];
      for (const key of keys) {
        value = value?.[key];
      }
      return value || path;
    },
    [lang]
  );

  const toggleLang = useCallback(() => {
    setLang((prev) => (prev === 'en' ? 'he' : 'en'));
  }, []);

  const isRTL = lang === 'he';

  return (
    <LanguageContext.Provider value={{ lang, t, toggleLang, isRTL }}>
      <div dir={isRTL ? 'rtl' : 'ltr'}>{children}</div>
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
}
